import * as React from 'react'

export const radioGroupContext = React.createContext<{ name: string; type: 'small' | 'medium' | 'big' } | undefined>(
  undefined,
)
